//import './index.css';
import '../node_modules/slick-carousel/slick/slick.css';
import '../node_modules/slick-carousel/slick/slick-theme.css';
import './scss/main.scss';

import "./js/import-jquery";
import 'slick-carousel';
import './js/slick-scripts';

import './js/utils';
import './js/hash-scripts';

import './js/general-scripts';